<template>
  <footer>
    <div class="container-fluid">
      <div class="row">
        <nav class="col">
          <ul class="link-list">
              <LinkListItem v-for="link in links" v-bind:key="link.href" v-bind:href="link.href" v-bind:text="link.text" />
          </ul>
        </nav>
        <div class="col">
          <Phone number="+49 30 48483-650" />
        </div>
      </div>
      <hr class="white">
      <div>
        <div>
          <Copyright />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import LinkListItem from './LinkListItem.vue'
import Phone from './Phone.vue'
import Copyright from './Copyright.vue'

export default {
  name: 'Footer',
  props: {},
  components: {
    Copyright,
    LinkListItem,
    Phone
  },
  data () {
    return {
      links: [
        { href: 'https://www.gvl.de/datenschutz', text: 'Datenschutz' },
        { href: 'https://www.gvl.de/kontakformular', text: 'Kontaktformular' },
        { href: 'https://www.gvl.de/impressum', text: 'Impressum' }
      ]
    }
  }
}
</script>

<style lang="scss">
  footer {
    background-color: #000000;
    color: #ffffff;
    position: fixed;
    bottom: 0;
    width: 90%;
    font-weight: 600;
    padding: 0.5em 5%;

    .row {
      display: block;
      .col {
        width: 33%;
        height: 5em;
        margin-right: 1%;
        float: left;
      }
    }

    nav ul {
      list-style: none;
      padding: 0;
      margin: 0.2em 0 0 3em;
      text-align: left;
      li {
        a {
          color: white;
          &:visited {
            color: #ccc;
          }
        }
      }
    }

    hr.white {
      border: 1px solid white;
      clear: both;
      margin: 1em 0 0 0;
    }
  }
</style>
